/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Col, Image, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

export function  KorekApp(){
  
  return (
 <></>
  );
}
